import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/users";

export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort = '') {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getUser(staffId){
    return Repository.get(`${resource}/${staffId}`)
  },
  createUser(payload){
    return Repository.post(`${resource}`, payload)
  },
  updateUser(staff_id, payload){
    return Repository.put(`${resource}/${staff_id}`, payload)
  },
  accountVerify(code) {
    return Repository.get(`/landlord/verify/${code}`)
  },
  forgotPassword(payload) {
    return Repository.post(`admin/forgot-password`, payload)
  },
  getForgotPasswordToken(token){
    return Repository.get(`admin/forgot-password/${token}`)
  },
  passwordReset(payload){
    return Repository.post(`admin/reset-password`, payload)
  },
  passwordChange(payload){
    return Repository.put(`/admin/staff/change-password`, payload)
  },
  getCurrencyList(){
    return Repository.get(`admin/currencies`)
  },
  resendWelcomeEmail(email) {
    return Repository.put(`/landlord/${email}/user-resend`)
  },
  changeUserStatus(user_id, status){ 
    return Repository.put(`/landlord/user/${user_id}/${status}`)
  },

  // 2fa
  get2FAQRCode(staff_id) {
    return Repository.get(`/landlord/2fa/${staff_id}/show-2fa-code`)
  },
  enable2FA(payload, staff_id) {
    return Repository.put(`/landlord/2fa/${staff_id}/enable-2fa`, payload)
  },
  disable2FA(payload, staff_id) {
    return Repository.put(`/landlord/2fa/${staff_id}/disable-2fa`, payload)
  },

  uploadProfileImage(auth_id, payload) {
    return Repository.put(`/admin/${auth_id}/staff-avatar`, payload)
  },
};
